import {Injectable} from '@angular/core';
import {Event, NavigationEnd, Router} from "@angular/router";
import {environment} from "@environments/environment";
import {HttpClient} from "@angular/common/http";
import {AccountManagerService} from "./account-manager-service";
import {RestApiManager} from "./rest-api-manager";
import {DEBUG, DebugService} from "./debug.service";

@Injectable({
  providedIn: 'root'
})
export class TrackingManagerService {

  private userKeepAliveLoop;

  constructor(
    private router: Router,
    private httpClient: HttpClient,
    private restApiManager: RestApiManager,
    private accountManagerService: AccountManagerService,
    private debugService: DebugService,
  ) {
    this.startScheduleRecorderLoop();
  }

  /**
   * Used to track user activity to schedule a proper number of recorder instances when navigating in portal
   **/
  startScheduleRecorderLoop() {

    if (!environment.recorder.enableTracking) {
      return;
    }

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        if (event.urlAfterRedirects != '/maintenance') {
          // If i am not on maintenance page you can remove userKeepAliveLoop -> no need to record
          if (this.userKeepAliveLoop) {
            clearInterval(this.userKeepAliveLoop);
          }
        }
      }
    });
  }

  /**
   * One shot recorder scheduler
   **/
  scheduleRecorder() {

    if (!environment.recorder.enableTracking) {
      return;
    }

    const keepAliveFn = () => {
      this.restApiManager.post(
        `${environment.recorder.endpoint}/track/web`,
        {
          userId: this.accountManagerService.account.id
        },
        this.accountManagerService.account.authToken
      ).then().catch(err => this.debugService.error(DEBUG.TRACKING, 'An error has occurred', err));
    }
    keepAliveFn();
    this.userKeepAliveLoop = setInterval(keepAliveFn, environment.recorder.userKeepAliveInterval * 1000);
  }

}
